import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { addSection, fetchList } from './Questionnaires.actions';
import { Action } from '@reduxjs/toolkit';
import {
  addQuestionnaire,
  setActiveQuestionnaire,
  setIsFetching,
  setList,
  setPage,
  setTotal,
} from './Questionnaires.slice';
import { RootState } from '../../app/store';
import { Unwrap } from '../../domains/app';
import QuestionnarieService from '../../service/Questionnarie.service';
import { QuestionSeries } from './questionnaires';
import { cloneDeep } from 'lodash';

function* fetchListQuestionnaire(action: Action) {
  try {
    yield put(setIsFetching(true));
    if (fetchList.match(action)) {
      const refreshList = action.payload;
      if (refreshList) {
        yield put(setPage(0));
      }
      const page: number = yield select(
        (state: RootState) => state.questionnaires.page,
      );
      const pageSize: number = yield select(
        (state: RootState) => state.questionnaires.pageSize,
      );
      const search: string = yield select(
        (state: RootState) => state.questionnaires.search,
      );

      const res: Unwrap<ReturnType<
        typeof QuestionnarieService.fetchListQuestionnaire
      >> = yield call(
        QuestionnarieService.fetchListQuestionnaire,
        pageSize,
        page,
        search,
      );
      if (refreshList) {
        yield put(setList([]));
      }
      yield put(addQuestionnaire(res.items));
      yield put(setTotal(res.total));
      yield put(setPage(page + 1));
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

function* addSectionSage(action: Action) {
  try {
    if (addSection.match(action)) {
      const activeQuestionnaire: RootState['questionnaires']['activeQuestionnaire'] = yield select(
        (state: RootState) => state.questionnaires.activeQuestionnaire,
      );
      const profile: RootState['app']['user'] = yield select(
        (state: RootState) => state.app.user,
      );
      if (activeQuestionnaire && profile) {
        const profile: RootState['app']['user'] = yield select(
          (state: RootState) => state.app.user,
        );
        const newSection: QuestionSeries = {
          name: '',
          questions: [],
          personId: profile?.id as string,
        };

        const newActive = cloneDeep(activeQuestionnaire);
        newActive.questionSeries.splice(
          action.payload.seriesIdx,
          0,
          newSection,
        );

        yield put(setActiveQuestionnaire(newActive));
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([
    takeLatest(fetchList.toString(), fetchListQuestionnaire),
    takeLatest(addSection.toString(), addSectionSage),
  ]);
}
